import { SvgIcon, SvgIconProps } from "@mui/material";

const VectorIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M9.70394 0.599889L6.00044 4.1352L2.29693 0.599889C1.92467 0.244536 1.32333 0.244536 0.95107 0.599889C0.57881 0.955242 0.57881 1.52927 0.95107 1.88463L5.33228 6.06686C5.70454 6.42221 6.30588 6.42221 6.67814 6.06686L11.0593 1.88463C11.4316 1.52927 11.4316 0.955242 11.0593 0.599889C10.6871 0.253647 10.0762 0.244536 9.70394 0.599889Z" fill="currentColor"/>
    </SvgIcon>
);

export default VectorIcon;
